import React, { useEffect, useState } from 'react'
import { BiLogoFacebookCircle } from "react-icons/bi";
import { IoLogoTwitter } from "react-icons/io5";
import { RiInstagramFill } from "react-icons/ri";
import './style/headerline.css'

const HeaderLine = () => {
    const [contentIndex, setContentIndex] = useState(0);
    useEffect(() => {
        const timer = setTimeout(() => {
            setContentIndex((prevIndex) => (prevIndex + 1) % 3);
        }, 3000);
        return () => clearTimeout(timer);
    }, [contentIndex]);
    return (
        <div className='flex justify-between bg-black  h-10'>
            <div className='flex opacity-0 md:opacity-100 py-3 px-7'>
                <span className='text-white px-2 mt-1'><BiLogoFacebookCircle /></span>
                <span className='text-white px-2 mt-1 '><IoLogoTwitter /></span>
                <span className='text-white px-2 mt-1'><RiInstagramFill /></span>
            </div>
            <div className='flex'>
                <div className="typed-items ">
                    <span className={`typed-item text-white uppercase font-semibold text-xs tracking-widest mt-1`}>FREE SHIPPING ON ALL ORDERS OVER $75</span>
                    <span className={`typed-item text-white uppercase font-semibold text-xs tracking-widest mt-1`}>News: Delivery to the door is active!</span>
                    <span className={`typed-item text-white uppercase font-semibold text-xs tracking-widest mt-1`}>You can pay with cryptocurrencies!</span>
                    <span className={`typed-item text-white uppercase font-semibold text-xs tracking-widest mt-1`}>FREE SHIPPING ON ALL ORDERS OVER $75</span>
                    <span className={`typed-item text-white uppercase font-semibold text-xs tracking-widest mt-1`}>You can pay with cryptocurrencies!!!!!!</span>
                    </div>
            </div>
            <div className='flex py-3 px-7'>
                <p className='text-white uppercase font-semibold text-xs tracking-widest mt-1 px-2'>search</p>
                <p className='text-white uppercase font-semibold text-xs tracking-widest mt-1 px-2'>help</p>
            </div>
        </div>
    )
}

export default HeaderLine
